export function filterNotNullOrUndefined<T>(array: Array<T | null | undefined>): T[] {
    return array.filter((x) => x !== undefined && x !== null) as T[];
}
